import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { AddProfessionalReviewCandidate } from "../../../types/addReviewCandidate";

import RatingTable from "../RatingTable";

const DevelopmentGrowthStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tProfReport } = useTranslation("goHire", {
    keyPrefix: "components.reviewCandidateModal.professionalReport",
  });

  const { control } = useFormContext<AddProfessionalReviewCandidate>();

  const skills: { title: string; description: string; fieldName: keyof AddProfessionalReviewCandidate }[] = [
    {
      title: tProfReport("learningOrientation"),
      description: tProfReport("dedicationToContinuousImprovement"),
      fieldName: "learningOrientation",
    },
    {
      title: tProfReport("adaptability"),
      description: tProfReport("flexibilityInAdoptingNewTools"),
      fieldName: "adaptability",
    },
    {
      title: tProfReport("futurePotential"),
      description: tProfReport("suitabilityForTheRoleApplied"),
      fieldName: "futurePotential",
    },
    {
      title: tProfReport("specializationFit"),
      description: tProfReport("suitabilityForTheRoleApplied"),
      fieldName: "specializationFit",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={skills} control={control} />
    </Box>
  );
};

export default DevelopmentGrowthStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
